'use strict';
import React, {Component} from 'react';

import GridItem from "./GridItem"
import createClass from 'create-react-class';

export default createClass({
    renderRows(delta){
      return this.props.gameState.rows.map(this.renderRow(delta))
    },
    renderRow(delta){
        return (r,i) => {
            return (
                <g style={styles.row} key={i}>
                    {r.map((item, j) => {
                        return <GridItem item={item}
                                         key={j}
                                         delta={delta}
                                         x={j}
                                         y={i}
                                         onClick={() => this.props.onClick(item)}/>
                    })}
                </g>
            )
        }
    },
    render(){
        const n = this.props.gameState.rows.length;
        const delta = 100.0/n;

        return (
            <svg viewBox="0 0 100 100" >
                {this.renderRows(delta)}
            </svg>
        )
    }
});

const styles = {
    grid: {
        flexDirection: "column",
        justifyContent: "center"
    },
    row: {
        flexDirection: "row",
        justifyContent: "center"

    }
};


// WEBPACK FOOTER //
// ./src/components/rgb/components/game/Grid.js